import React from "react";
import PropTypes from "prop-types";
import CreditWhite from "../icons/credit-white.svg";
import CreditGrey from "../icons/credit-grey.svg";

const PaymentDetailStepIcon = ({ show, completed }) => {
  const iconSrc = show || completed ? CreditWhite : CreditGrey;

  return (
    <div className="stepLeft">
      <img
        src={iconSrc}
        alt="Payment Step Icon"
        // style={{ height: 24, width: 24 }}
      />
    </div>
  );
};



PaymentDetailStepIcon.propTypes = {
  completed: PropTypes.any,
  show: PropTypes.bool,
};

export default PaymentDetailStepIcon;
